<span>
            <img src="assets/images/user-profile.svg" alt="">
             <span class="ml-2">{{currentUser.userName}}
               <div class="ml-5 user-details"> {{role}}</div>
             </span>
    </span>
